import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { http } from "../../../utils";

export async function fetchFAQCategory({ status }) {
  const queryParams = new URLSearchParams();
  if (status) {
    queryParams.append("status", status);
  }
  queryParams.append("pageSize", 100);
  const { data } = await http(`/admin/faq-category?${queryParams.toString()}`);

  return data;
}

export function useFAQCategory({ status } = {}) {
  const { data, ...raResult } = useQuery(["faq-category", status], () =>
    fetchFAQCategory({ status })
  );

  return {
    ...raResult,
    data: data ?? {},
  };
}

async function addFaqCategory(formData) {
  const data = await http(`/admin/faq-category`, {
    data: formData,
  });
  return data;
}

export function useAddFaqCategory() {
  const queryClient = useQueryClient();

  return useMutation(addFaqCategory, {
    onSuccess: () => {
      queryClient.refetchQueries(["faq-category"]);
    },
  });
}

export function useUpdateFaqCategory() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  return useMutation(
    async (data) => {
      const { id, ...payload } = data;
      const res = await http(`/admin/faq-category/${id}`, {
        method: "PUT",
        data: payload,
      });
      return res;
    },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(["faq-category"]);
        setTimeout(() => {
          navigate("/bulletin-board/faq/management");
        }, 1500);
      },
    }
  );
}

async function deleteFaqCategoryById(id) {
  const data = await http(`/admin/faq-category/${id}`, {
    method: "DELETE",
  });

  return data;
}

export function useDeleteFaqCategoryById() {
  const queryClient = useQueryClient();

  return useMutation(deleteFaqCategoryById, {
    onSuccess: () => {
      queryClient.invalidateQueries(["faq-category"]);
    },
  });
}
